'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiExport = function TiExport(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 27.5v0.8c2.9-4.3 6-6.6 10-6.6v5c0 0.9 0.9 1.6 1.9 1.6 0.6 0 1.2-0.2 1.5-0.6 3.2-3.4 10-10.2 10-10.2s-6.8-6.8-10-10.2c-0.3-0.4-0.9-0.6-1.5-0.6-1 0-1.9 0.7-1.9 1.6v5c-7.7 0-10 8.2-10 14.2z m-5 7.5h23.4c0.9 0 1.6-0.7 1.6-1.7v-10c-1.1 1.1-2.2 2.3-3.3 3.4v5h-20v-20h11.7v-3.4h-13.4c-0.9 0-1.6 0.8-1.6 1.7v23.3c0 1 0.7 1.7 1.6 1.7z' })
        )
    );
};

exports.default = TiExport;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/export.js
// module id = 1881
// module chunks = 0